<template>
  <div>
    <serveur-info :erreur="erreur" />
    <my-notification :icon="'lightbulb-o'">
      <template #title
        >{{ $t('compTransitionReviewerReviewReminder.reminder') }}
      </template>
      <p>
        {{ $t('compTransitionReviewerReviewReminder.info') }}
      </p>
    </my-notification>

    <actions-table
      :actions="actions"
      :searchable="true"
      :withValidColumn="true"
      :withActionId="true"
      :withReviewerColumn="true"
      :withLabColumn="true"
      :withReminderColumn="true"
      :rowClass="rowClass"
    >
      <!-- custom stuff on the last column-->
      <template #custom="slotProps">
        <b-tooltip :label="$t('action-assign')" type="is-black">
          <b-button
            size="is-small"
            icon-left="list"
            @click="assignAction(slotProps.action)"
          />
        </b-tooltip>

        <b-tooltip :label="$t('action-review')" type="is-black">
          <b-button
            size="is-small"
            icon-left="eye"
            @click="reviewAction(slotProps.action)"
          />
        </b-tooltip>

        <b-tooltip :label="$t('action-publish')" type="is-black">
          <b-button
            size="is-small"
            icon-left="check"
            @click="confirmPublish(slotProps.action)"
          />
        </b-tooltip>
      </template>
    </actions-table>
  </div>
</template>

<script>
import { Background } from '@/mixins/background.js'
import transitionService from '@/services/transitionService.js'
import {
  PublicAction,
  insertOrUpdateInList
} from '@/models/transition/transition.js'

export default {
  name: 'GES1point5Admin',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'actions-table': () => import('@/components/transition/ActionsTable.vue')
  },
  mixins: [Background],
  data () {
    return {
      erreur: null,
      actions: [],
      currentLab: {},
      currentQuota: 0,
      currentMaxQuota: 0
    }
  },
  watch: {},
  methods: {
    rowClass (row, index) {
      return row.isReminderLate() ? 'is-late' : ''
    },
    confirmPublish (action) {
      this.$buefy.dialog.confirm({
        title: this.$t('confirm-title'),
        message: this.$t('compTransitionReviewerReviewReminder.ask-publish'),
        confirmText: this.$t('validate'),
        cancelText: this.$t('cancel'),
        canCancel: ['escape', 'button', 'outside'],
        onConfirm: () => this.publish(action)
      })
    },
    assignAction (action) {
      this.bgUI(async () => {
        let data = await transitionService.reviewerAssignAction(action.id)
        let newAction = PublicAction.fromDatabase(data)
        insertOrUpdateInList(this.actions, newAction)
      })
    },
    publish (action) {
      this.bgUI(async () => {
        let data = await transitionService.reviewerTogglePublishAction(
          action.id
        )
        let newAction = PublicAction.fromDatabase(data)
        insertOrUpdateInList(this.actions, newAction)
      })
    },
    /**
     * Open in a new tab
     * so that reviewer can review several actions in a row
     *
     * @param {} action
     */

    reviewAction (action) {
      let route = this.$router.resolve({
        path: `/transition-1point5/reviewer/actions/${action.id}`
      })
      window.open(route.href, '_blank')
    }
  },
  mounted () {
    this.bgUI(async () => {
      let data = await transitionService.reviewerGetReminders()
      this.actions = data.map((d) => PublicAction.fromDatabase(d))
    })
  }
}
</script>

<style>
tr.is-late {
  background: rgb(253, 215, 215) !important;
}
</style>
